import Component from "@glimmer/component";
import PluginOutlet from "discourse/components/plugin-outlet";
import concatClass from "discourse/helpers/concat-class";
import lazyHash from "discourse/helpers/lazy-hash";
import { stringToClassname } from "../../../lib/html-helpers";

export default class SearchFieldWireFrame extends Component {
  get classNames() {
    return [
      "circles-search-filter",
      "circles-search-filter__" + stringToClassname(this.args.filter.name),
    ].join(" ");
  }

  <template>
    <PluginOutlet
      @name="circles-search-filter"
      @outletArgs={{lazyHash
        classNames=this.classNames
        controller=@controller
        filter=@filter
        value=@value
      }}
    >
      <div
        class={{concatClass this.classNames}}
        ...attributes
        data-filter-name={{@filter.name}}
        data-filter-type={{@filter.type}}
      >
        {{yield}}
      </div>
    </PluginOutlet>
  </template>
}
